import React, {useState} from "react"
import {Button, Modal} from "react-bootstrap"
import {delOrgRemoveMember, putOrgModifyMember, putTeamModifyMember} from "../../lib/api";
import DropdownScope from "./DropdownScope";

function MemberEdit(props: {
  user?: any,
  orgId: string,
  teamId?: string,
  loadData: any,
  show: boolean;
  onHide: () => void;
}) {
  const {user, orgId, teamId, loadData, show, onHide} = props;
  const [error, setError] = useState(null);
  const [scope, setScope] = useState(currentScope());
  const [enabled, setEnabled] = useState(true);

  function currentScope() {
    if (user?.scopes.find((s: string) => s === 'org_user_admin' || s === 'team_user_admin')) {
      return 'Admin';
    } else if (user?.scopes.find((s: string) => s === 'org_user_member' || s === 'team_user_member')) {
      return 'Member';
    } else {
      return 'Guest';
    }
  }

  function showModal() {
    setScope(currentScope());
    setEnabled(true);
    setError(null);
  }

  function removeUser() {
    const answer = window.confirm("Are you sure you want to remove Member?")
    if (!answer) {
      return;
    }

    delOrgRemoveMember(orgId, user.id)
      .then(responseHandler);
  }

  function editUser() {
    setError(null);
    setEnabled(false);

    if (teamId) {
      putTeamModifyMember(orgId, teamId!, user.id, scope)
        .then(responseHandler);
    } else {
      putOrgModifyMember(orgId, user.id, scope)
        .then(responseHandler);
    }
  }

  function formatUser() {
    if (user.givenName && user.familyName) {
      return `${user.givenName} ${user.familyName}, ${user.email}`;
    } else {
      return user.email;
    }
  }

  function responseHandler(response: any) {
    setEnabled(true);
    if (response.ok) {
      onHide()
      loadData()
    } else {
      // @ts-ignore
      response.json().then(json => {
        setError(json?.error);
      });
    }
  }

  if (!user) {
    return null;
  }

  let title: string;
  const scopes = ['Member'];
  if (teamId) {
    title = 'Edit Villa Member';
    scopes.push('Guest');
  } else {
    title = 'Edit Organization Member';
    scopes.push('Admin');
  }
  if (scopes.indexOf(currentScope()) === -1) {
    scopes.push(currentScope());
  }

  return (
    <Modal show={show}
           className="member-edit"
           animation={false}
           onShow={showModal}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row pb-3">
          <div className="col">
            {formatUser()}
          </div>
        </div>
        <DropdownScope titleScope="Change to" scope={scope} setScope={setScope} scopes={scopes}/>
        {error ?
          (
            <div className="row error">
              <div className="col">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <div className="col text-right">
            <Button
              variant="secondary"
              className="mx-4"
              onClick={removeUser}
              disabled={!enabled}
            >
              Remove Member
            </Button>
            <Button
              variant="secondary"
              className="ml-2"
              onClick={onHide}
              disabled={!enabled}
            >
              Cancel
            </Button>
            <Button
              onClick={editUser}
              style={{marginLeft: "10px"}}
              variant="primary"
              disabled={!enabled}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default MemberEdit;
